/* Zoley — interacción del tema (sin dependencias). */
(function () {
  "use strict";

  var raiz = document.documentElement;
  var cuerpo = document.body;

  var pesos = function (centavos) {
    return "$" + Math.round(centavos / 100).toLocaleString("es-CO");
  };

  var bloquear = function (si) {
    cuerpo.style.overflow = si ? "hidden" : "";
  };

  var reducido = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ────────────────────────────── Telón de entrada ───────────────────────── */
  (function () {
    var intro = document.getElementById("intro");
    if (!intro) return;
    var visto = true;
    try {
      visto = sessionStorage.getItem("zoley-intro") === "1";
    } catch (e) {
      visto = true;
    }
    if (visto || reducido) {
      raiz.dataset.intro = "seen";
      intro.classList.add("listo");
      return;
    }
    bloquear(true);
    var salir = function () {
      clearTimeout(reloj);
      intro.classList.add("listo");
      bloquear(false);
      try {
        sessionStorage.setItem("zoley-intro", "1");
      } catch (e) {
        /* sin storage */
      }
    };
    var reloj = setTimeout(salir, 4000);
    intro.addEventListener("click", salir);
  })();

  /* ─────────────────────────────── Encabezado ────────────────────────────── */
  (function () {
    var encabezado = document.querySelector(".encabezado");
    if (!encabezado) return;
    var alScroll = function () {
      encabezado.classList.toggle(
        "solido",
        window.scrollY > 40 && !cuerpo.classList.contains("menu-abierto")
      );
    };
    alScroll();
    window.addEventListener("scroll", alScroll, { passive: true });

    var menu = document.getElementById("menu-movil");
    document.querySelectorAll("[data-menu]").forEach(function (b) {
      b.addEventListener("click", function () {
        var abierto = cuerpo.classList.toggle("menu-abierto");
        if (menu) menu.classList.toggle("abierto", abierto);
        bloquear(abierto);
        alScroll();
      });
    });
    if (menu) {
      menu.querySelectorAll("a").forEach(function (a) {
        a.addEventListener("click", function () {
          cuerpo.classList.remove("menu-abierto");
          menu.classList.remove("abierto");
          bloquear(false);
        });
      });
    }
  })();

  /* ─────────────────────── Revelados al hacer scroll ─────────────────────── */
  (function () {
    var nodos = document.querySelectorAll(".rv");
    if (!nodos.length) return;
    if (!("IntersectionObserver" in window) || reducido) {
      nodos.forEach(function (el) {
        el.classList.add("in");
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.05 }
    );
    nodos.forEach(function (el) {
      io.observe(el);
    });
  })();

  /* ──────────────────────── Carrito: drawer + AJAX ───────────────────────── */
  var abrirBolsa, refrescarBolsa;
  (function () {
    var drawer = document.getElementById("bolsa");
    var lista = document.getElementById("bolsa-items");
    var vacio = document.getElementById("bolsa-vacia");
    var pie = document.getElementById("bolsa-pie");
    var totalEl = document.getElementById("bolsa-total");
    var contadores = document.querySelectorAll("[data-bolsa-conteo]");

    abrirBolsa = function () {
      if (!drawer) return;
      cuerpo.classList.add("bolsa-abierta");
      bloquear(true);
      var cerrar = drawer.querySelector("[data-cerrar-bolsa]");
      if (cerrar) cerrar.focus();
    };
    var cerrarBolsa = function () {
      cuerpo.classList.remove("bolsa-abierta");
      bloquear(false);
    };

    document.querySelectorAll("[data-abrir-bolsa]").forEach(function (b) {
      b.addEventListener("click", function (e) {
        e.preventDefault();
        abrirBolsa();
      });
    });
    document.querySelectorAll("[data-cerrar-bolsa]").forEach(function (b) {
      b.addEventListener("click", cerrarBolsa);
    });

    var pintar = function (carrito) {
      contadores.forEach(function (c) {
        c.textContent = carrito.item_count > 0 ? " (" + carrito.item_count + ")" : "";
      });
      if (!drawer) return;
      var hay = carrito.item_count > 0;
      if (vacio) vacio.hidden = hay;
      if (lista) lista.hidden = !hay;
      if (pie) pie.hidden = !hay;
      if (totalEl) totalEl.textContent = pesos(carrito.items_subtotal_price);
      if (!lista) return;
      lista.innerHTML = carrito.items
        .map(function (it) {
          var foto = it.image
            ? it.image.replace(/(\.[a-z0-9]+)(\?.*)?$/i, "_240x$1$2")
            : "";
          var talla = it.variant_title && it.variant_title !== "Default Title"
            ? "Talla " + it.variant_title.split(" / ").join(" · ")
            : "";
          return (
            '<li data-clave="' + it.key + '">' +
            '<a class="item-foto" href="' + it.url + '">' +
            (foto ? '<img src="' + foto + '" alt="" loading="lazy">' : "") +
            "</a>" +
            '<div class="item-cuerpo">' +
            "<div>" +
            '<a class="item-nombre" href="' + it.url + '">' + it.product_title + "</a>" +
            '<p class="item-talla">' + talla + "</p>" +
            "</div>" +
            '<div class="item-pie">' +
            '<div class="qty" role="group" aria-label="Cantidad">' +
            '<button type="button" data-qty="-1" aria-label="Quitar una unidad">−</button>' +
            "<span>" + it.quantity + "</span>" +
            '<button type="button" data-qty="1" aria-label="Agregar una unidad">+</button>' +
            "</div>" +
            '<p class="item-precio">' + pesos(it.final_line_price) + "</p>" +
            "</div></div>" +
            '<button type="button" class="item-quitar" data-quitar>Quitar</button>' +
            "</li>"
          );
        })
        .join("");
    };

    refrescarBolsa = function () {
      return fetch("/cart.js")
        .then(function (r) {
          return r.json();
        })
        .then(pintar)
        .catch(function () {
          /* sin red: la bolsa se queda como la pintó Liquid */
        });
    };

    var cambiar = function (clave, cantidad) {
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: clave, quantity: cantidad }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(pintar);
    };

    if (lista) {
      lista.addEventListener("click", function (e) {
        var fila = e.target.closest("li[data-clave]");
        if (!fila) return;
        var clave = fila.getAttribute("data-clave");
        var n = parseInt(fila.querySelector(".qty span").textContent, 10) || 1;
        if (e.target.closest("[data-quitar]")) {
          cambiar(clave, 0);
        } else if (e.target.closest("[data-qty]")) {
          var delta = parseInt(
            e.target.closest("[data-qty]").getAttribute("data-qty"),
            10
          );
          cambiar(clave, Math.max(0, n + delta));
        }
      });
    }

    window.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      if (cuerpo.classList.contains("bolsa-abierta")) cerrarBolsa();
      if (cuerpo.classList.contains("guia-abierta"))
        cuerpo.classList.remove("guia-abierta");
      if (cuerpo.classList.contains("menu-abierto")) {
        cuerpo.classList.remove("menu-abierto");
        var m = document.getElementById("menu-movil");
        if (m) m.classList.remove("abierto");
        bloquear(false);
      }
    });

    if (drawer) refrescarBolsa();
  })();

  /* ───────────────── Ficha: tallas, galería y agregar a la bolsa ──────────── */
  (function () {
    var forma = document.getElementById("forma-producto");
    if (!forma) return;

    var campoId = forma.querySelector("[data-variante-id]");
    var aviso = document.getElementById("talla-aviso");
    var boton = forma.querySelector('button[type="submit"]');
    var etiqueta = document.getElementById("boton-etiqueta");
    var elPrecio = document.querySelector("[data-precio]");
    var elAntes = document.querySelector("[data-precio-antes]");
    var variantes = [];
    var datos = forma.querySelector("[data-variantes]");
    try {
      variantes = JSON.parse(datos.textContent);
    } catch (e) {
      variantes = [];
    }
    var grupos = forma.querySelectorAll(".opcion-grupo").length;

    var elegidas = function () {
      var sel = [];
      forma.querySelectorAll("input[data-opcion]:checked").forEach(function (r) {
        sel[parseInt(r.getAttribute("data-opcion"), 10)] = r.value;
      });
      return sel;
    };

    var buscar = function (sel) {
      var puestas = 0;
      for (var s = 0; s < grupos; s++) if (sel[s]) puestas++;
      if (puestas !== grupos) return null;
      for (var i = 0; i < variantes.length; i++) {
        var ok = true;
        for (var j = 0; j < grupos; j++) {
          if (variantes[i].opciones[j] !== sel[j]) {
            ok = false;
            break;
          }
        }
        if (ok) return variantes[i];
      }
      return null;
    };

    var pintar = function () {
      if (!grupos) return;
      var v = buscar(elegidas());
      if (campoId) campoId.value = v ? v.id : "";
      if (!v) return;
      if (aviso) aviso.hidden = true;
      if (elPrecio) elPrecio.textContent = v.precio_fmt;
      if (elAntes) {
        var oferta = v.antes > v.precio;
        elAntes.hidden = !oferta;
        elAntes.textContent = oferta ? v.antes_fmt : "";
      }
      if (boton) boton.disabled = !v.disponible;
      if (etiqueta) {
        etiqueta.textContent = v.disponible
          ? "Agregar a la bolsa — " + v.precio_fmt
          : "Agotada";
      }
    };

    forma.querySelectorAll("input[data-opcion]").forEach(function (r) {
      r.addEventListener("change", pintar);
    });
    pintar();

    forma.addEventListener("submit", function (e) {
      e.preventDefault();
      var id = campoId && campoId.value ? parseInt(campoId.value, 10) : 0;
      if (!id) {
        if (aviso) aviso.hidden = false;
        return;
      }
      boton.disabled = true;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: id, quantity: 1 }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error("no se pudo agregar");
          return refrescarBolsa();
        })
        .then(abrirBolsa)
        .catch(function () {
          window.location.href = "/cart";
        })
        .finally(function () {
          boton.disabled = false;
        });
    });
  })();

  /* Galería de la ficha */
  (function () {
    var minis = document.querySelectorAll("[data-mini]");
    if (!minis.length) return;
    var fotos = document.querySelectorAll("[data-foto]");
    minis.forEach(function (m) {
      m.addEventListener("click", function () {
        var i = m.getAttribute("data-mini");
        fotos.forEach(function (f) {
          f.classList.toggle("activa", f.getAttribute("data-foto") === i);
        });
        minis.forEach(function (x) {
          x.classList.toggle("activa", x === m);
        });
      });
    });
  })();

  /* Guía de tallas */
  (function () {
    var abre = document.querySelectorAll("[data-abrir-guia]");
    if (!abre.length) return;
    abre.forEach(function (b) {
      b.addEventListener("click", function () {
        cuerpo.classList.add("guia-abierta");
      });
    });
    document.querySelectorAll("[data-cerrar-guia]").forEach(function (b) {
      b.addEventListener("click", function () {
        cuerpo.classList.remove("guia-abierta");
      });
    });
  })();

  /* ──────────────── Índice de colecciones: foto que sigue al cursor ───────── */
  (function () {
    var indice = document.querySelector("[data-drops]");
    if (!indice) return;
    var flotante = indice.querySelector(".drop-flotante");
    if (!flotante || !window.matchMedia("(pointer: fine)").matches) return;
    var fotos = flotante.querySelectorAll("img");

    indice.addEventListener("mousemove", function (e) {
      flotante.style.transform =
        "translate(" + (e.clientX + 30) + "px, " + (e.clientY - 140) + "px) rotate(2deg)";
    });
    indice.querySelectorAll("[data-drop]").forEach(function (fila) {
      var slug = fila.getAttribute("data-drop");
      fila.addEventListener("mouseenter", function () {
        flotante.classList.add("visible");
        fotos.forEach(function (f) {
          f.classList.toggle("activa", f.getAttribute("data-drop") === slug);
        });
      });
      fila.addEventListener("mouseleave", function () {
        flotante.classList.remove("visible");
      });
    });
  })();

  /* ─────────────────────────── Videos: portada y reels ───────────────────── */
  (function () {
    var portada = document.querySelector(".portada-video");
    if (portada && !reducido) {
      var p = portada.play();
      if (p && p.catch) p.catch(function () {});
    }

    var reels = document.querySelectorAll(".reel video");
    if (!reels.length || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            if (!v.getAttribute("src") && v.getAttribute("data-src")) {
              v.src = v.getAttribute("data-src");
            }
            if (!reducido) {
              var pr = v.play();
              if (pr && pr.catch) pr.catch(function () {});
            }
          } else if (!v.paused) {
            v.pause();
          }
        });
      },
      { threshold: 0.35 }
    );
    reels.forEach(function (v) {
      io.observe(v);
    });
  })();

  /* ─────────────────────── Cursor "hilo de seda" ─────────────────────────── */
  (function () {
    if (!window.matchMedia("(pointer: fine)").matches || reducido) return;
    var LARGO = 14;
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("class", "cursor-hebra");
    svg.setAttribute("aria-hidden", "true");
    svg.style.width = "100vw";
    svg.style.height = "100vh";
    var hebra = document.createElementNS("http://www.w3.org/2000/svg", "polyline");
    hebra.setAttribute("fill", "none");
    hebra.setAttribute("stroke", "var(--amber)");
    hebra.setAttribute("stroke-width", "1");
    hebra.setAttribute("stroke-linecap", "round");
    hebra.setAttribute("stroke-linejoin", "round");
    hebra.setAttribute("opacity", "0.75");
    svg.appendChild(hebra);

    var punto = document.createElement("div");
    punto.className = "cursor-punto";
    punto.setAttribute("aria-hidden", "true");
    cuerpo.append(svg, punto);

    var pts = [];
    var mx = -100;
    var my = -100;
    cuerpo.classList.add("cursor-fuera");

    window.addEventListener(
      "mousemove",
      function (e) {
        mx = e.clientX;
        my = e.clientY;
        cuerpo.classList.remove("cursor-fuera");
        var t = e.target;
        var sobre = t && t.closest && t.closest("a, button, [role=button], input, select, label");
        cuerpo.classList.toggle("cursor-sobre", !!sobre);
      },
      { passive: true }
    );
    raiz.addEventListener("mouseleave", function () {
      cuerpo.classList.add("cursor-fuera");
    });

    var tic = function () {
      punto.style.transform = "translate(" + mx + "px, " + my + "px)";
      pts.push({ x: mx, y: my });
      if (pts.length > LARGO) pts.shift();
      hebra.setAttribute(
        "points",
        pts
          .map(function (p) {
            return p.x + "," + p.y;
          })
          .join(" ")
      );
      requestAnimationFrame(tic);
    };
    requestAnimationFrame(tic);
  })();

  /* ────────────── Popup de bienvenida (10% de la primera compra) ──────────── */
  (function () {
    var popup = document.getElementById("popup-news");
    if (!popup) return;
    var CLAVE_HECHO = "zoley-news";
    var CLAVE_VISTO = "zoley-news-seen";
    try {
      if (localStorage.getItem(CLAVE_HECHO) || sessionStorage.getItem(CLAVE_VISTO)) return;
    } catch (e) {
      return;
    }

    var cerrar = function () {
      popup.hidden = true;
      raiz.style.overflow = "";
      try {
        sessionStorage.setItem(CLAVE_VISTO, "1");
      } catch (e) {
        /* sin storage */
      }
    };

    var reloj = setTimeout(function () {
      popup.hidden = false;
      raiz.style.overflow = "hidden";
    }, 6500);

    popup.querySelectorAll("[data-cerrar-popup]").forEach(function (b) {
      b.addEventListener("click", cerrar);
    });
    window.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !popup.hidden) cerrar();
    });
    window.addEventListener("beforeunload", function () {
      clearTimeout(reloj);
    });

    var forma = popup.querySelector("form");
    if (!forma) return;
    forma.addEventListener("submit", function (e) {
      e.preventDefault();
      var correo = forma.querySelector('input[type="email"]');
      if (!correo || !correo.value) return;
      var boton = forma.querySelector('button[type="submit"]');
      if (boton) boton.disabled = true;
      fetch(forma.action, {
        method: "POST",
        body: new FormData(forma),
        headers: { Accept: "text/html" },
      })
        .catch(function () {
          /* si falla el envío igual se muestra el código: no se pierde la venta */
        })
        .finally(function () {
          try {
            localStorage.setItem(CLAVE_HECHO, correo.value.trim().toLowerCase());
          } catch (err) {
            /* sin storage */
          }
          var paso1 = popup.querySelector("[data-paso-suscribir]");
          var paso2 = popup.querySelector("[data-paso-listo]");
          if (paso1) paso1.hidden = true;
          if (paso2) paso2.hidden = false;
          if (boton) boton.disabled = false;
        });
    });
  })();
})();
